export default function SearchBarometerButton({ onPress }) {

    return (
        <div className="el-sorting__graph">
            <a role='button' className="el-sorting__graph-link"
                onClick={onPress}>
                <i className="icon-graph"></i>
                <span>{tMsg('График цен')}</span>
            </a>
        </div>
    )
}
